import { createPortal } from 'react-dom';

export default function Modal({ isOpen, setIsModalOpen, onClose, title, message, actionText, action, children }: any) {

    if (!isOpen) {
        return null;
    }

    const handleClose = () => {
        if (onClose) onClose();
        if (setIsModalOpen) setIsModalOpen(false);
    };
    
    return createPortal(
        <div id="modal-wrapper" className="fixed z-[10001] inset-0 bg-black/40 backdrop-blur-sm overflow-hidden overscroll-contain flex items-center justify-center p-4 animate-fade-in" onClick={handleClose}>
            <div className="bg-white p-6 md:p-8 rounded-2xl max-w-md w-full shadow-2xl relative flex flex-col" onClick={(e) => e.stopPropagation()}>
                {title && (
                    <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center">{title}</h3>
                )}
                
                {message && (
                    <p className='text-center text-gray-600 mb-4'>{message}</p>
                )}
                
                {children && (
                    <div className="w-full my-2">
                        {children}
                    </div>
                )}
                
                <div className="flex pt-6 justify-center gap-4 w-full">
                    {actionText && action && (
                        <button
                            onClick={() => action()}
                            className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2.5 px-8 rounded-xl shadow-sm transition-colors"
                        >
                            {actionText}
                        </button>
                    )}
                    <button
                        onClick={handleClose}
                        className="bg-white border-2 border-gray-200 text-gray-600 hover:bg-gray-50 hover:border-gray-300 font-bold py-2.5 px-8 rounded-xl transition-all"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}
